import { baseApi } from './baseApi';

const PROFILE_TAG = 'GeneticProfile';
const KNOWN_TAG = 'KnownMutations';

const geneticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchKnownMutations: builder.query({
      query: (category) => {
        const params = {};
        if (category) params.category = category;
        return {
          url: '/known-mutations/',
          method: 'GET',
          params,
        };
      },
      providesTags: [KNOWN_TAG],
      keepUnusedDataFor: 3600,
    }),
    fetchGeneticProfile: builder.query({
      query: () => ({
        url: '/genetic-profile/',
        method: 'GET',
      }),
      providesTags: [PROFILE_TAG],
    }),
    patchGeneticProfile: builder.mutation({
      query: ({ uuid, ...body }) => ({
        url: `/genetic-profile/${uuid}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [PROFILE_TAG],
    }),
    createGeneticVariant: builder.mutation({
      query: (body) => ({
        url: '/genetic-variants/',
        method: 'POST',
        body,
      }),
      invalidatesTags: [PROFILE_TAG],
    }),
    patchGeneticVariant: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/genetic-variants/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [PROFILE_TAG],
    }),
    deleteGeneticVariant: builder.mutation({
      query: (id) => ({
        url: `/genetic-variants/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [PROFILE_TAG],
    }),
  }),
});

export const {
  useFetchKnownMutationsQuery,
  useFetchGeneticProfileQuery,
  usePatchGeneticProfileMutation,
  useCreateGeneticVariantMutation,
  usePatchGeneticVariantMutation,
  useDeleteGeneticVariantMutation,
} = geneticsApi;
